import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import {createSelector} from 'reselect';
import AuthService from "../../admin/components/util/AuthService";
import ApiService from "../../admin/components/util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../../admin/components/util/LoadingScreen";
import {Link} from "react-router-dom";

const ProfileDropdown = () => {
    const [loadingPage, setLoadingPage] = useState(false);
    const profiledropdownData = createSelector(
        (state) => state.Profile,
        (user) => user.user
    );
    // Inside your component
    const user = AuthService.getUserData();
    console.log(user);
    let specialtyString = user.specialties.map(item => item.name).join(', ');

// Limita a 250 caracteres
    if (specialtyString.length > 250) {
        specialtyString = specialtyString.substring(0, 247) + '...';
    }


    const [userName, setUserName] = useState("Admin");


    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const getTextType = (id) => {
        switch (id) {
            case 1:
                return 'Médico';
            case 2:
                return 'Empresa';
            case 3:
                return 'Funcionário';
        }
    }

    const handleSubmitSenha = async () => {
        const result = await Swal.fire({
            title: 'Redefinir senha?',
            text: "Deseja realmente enviar a solicitação de redefinição de senha?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, enviar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            setLoadingPage(true); // Ativa o carregamento

            ApiService.send('post', process.env.REACT_APP_URL_API + 'password/forgot', {}, true)
                .then((response) => {
                    const {data} = ApiService.handleApiResponse(response);

                    if (data.message) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Solicitação enviada!',
                            text: data.message
                        });
                    }
                }).catch(() => {
                setLoadingPage(false);
                Swal.fire('Erro', 'Não foi possível enviar a solicitação.', 'error');
            }).finally(() => {
                setLoadingPage(false);
            });
        }
    };


    return (
        <>
            {loadingPage && <LoadingScreen/>}
            <React.Fragment>
                <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown}
                          className="ms-sm-3 header-item topbar-user">
                    <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                    <img
                        className="rounded-circle header-profile-user header-profile-user-perfil  object-fit-cover"
                        src={user.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                        id="header-profile-user-perfil"
                        alt="Perfil Imagem"
                        style={{width: '35px', height: '35px'}} // ajuste o tamanho desejado
                    />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{user.name}</span>
                            <span
                                className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{specialtyString}</span>
                        </span>
                    </span>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                        <h6 className="dropdown-header">Bem Vindo {user.name}!</h6>
                        <DropdownItem href="/admin/profile"><i
                            className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Perfil</span></DropdownItem>


                        <DropdownItem href="/admin/integrations">
                            <i className="mdi mdi-api text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Integrações</span>
                        </DropdownItem>


                        <DropdownItem onClick={() => handleSubmitSenha()}> <i
                            className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>

                            <span className="align-middle">Alterar Senha</span>
                        </DropdownItem>

                        <div className="dropdown-divider"></div>

                        <DropdownItem href="/admin/logout"><i
                            className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Sair</span></DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        </>

    );
};

export default ProfileDropdown;